import "styles/App.css";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Outlet } from "react-router-dom";
import styles from "styles/public.module.css";

function AccountContainer() {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_G_RECAPTCHA_SITE_KEY}
    >
      <div className="container account-auth-layout d-flex justify-content-center justify-content-xl-between align-items-center flex-wrap">
        <div className={styles["auth-hero"]}>
          <img
            className={styles["auth-hero-image"]}
            src="../../assets/melillo_method_image.png"
            alt="Melillo Method"
          />
          <h3 className={styles["auth-hero-title"]}>Melillo Method®</h3>
          <p className={styles["auth-hero-text"]}>
            Secure access to your patient portal, assessments, and care
            journey.
          </p>
        </div>
        <Outlet />
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default AccountContainer;
